import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/Pages/Home";
import About from "./Components/Pages/About";
import Productions from "./Components/Pages/Productions";
import ScrollToTop from "./Components/ScrollToTop";
import Navbar from "./Components/Navbar";
import MeetTheCrew from "./Components/Pages/MeetTheCrew";
import Productions2024 from "./Components/Pages/Productions2024";
import Productions2025 from "./Components/Pages/Productions2025";
import Productions2026 from "./Components/Pages/Productions2026";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" exact Component={Home} />
          <Route path="/about" exact Component={About} />
          <Route path="/productions" exact Component={Productions} />
          <Route path="/meetthecrew" exact Component={MeetTheCrew} />
          <Route path="/2024productions" exact Component={Productions2024} />
          <Route path="/2025productions" exact Component={Productions2025} />
          <Route path="/2026productions" exact Component={Productions2026} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
